<template>
    <div class="title-block">
        <div class="title-block__left">
            <div class="title-block__title">Станции метро</div>
        </div>
    </div>
    <div class="filter-table">
        <div class="filter-table__input-wrap search-control">
            <input @keyup.enter="onSearch()" @keyup.delete="onDeleteSearch()" type="text" v-model="name" class="search-control__input form-control" placeholder="Поиск">
            <button @click="onSearch()" class="search-control__input-btn reset-btn">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.5 8.333a5.834 5.834 0 1011.667 0 5.834 5.834 0 00-11.667 0zM17.5 17.5l-5-5"
                        stroke="currentColor" stroke-width="1.667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
        </div>

        <!-- <div class="filter-table__list-wrap">
            <ul class="filter-table__list">
                <li class="filter-table__item">
                    <v-select v-model="color"
                              :options="colors"
                              @update:modelValue="onChangeColor"
                              :reduce="name => name.id"
                              label="name"
                              :searchable="false"
                              :deselectFromDropdown="false"
                              :appendToBody="true"
                              :calculate-position="withPopper"
                              :clearable="false"
                              class="ftoggle">
                    </v-select>
                </li>
            </ul>
        </div>

        <div class="filter-table__list-wrap">
            <ul class="filter-table__list">
                <li class="filter-table__item">
                    <v-select v-model="line"
                              :options="lines"
                              @update:modelValue="onChangeBrand"
                              :reduce="name => name.id"
                              label="name"
                              :searchable="false"
                              :deselectFromDropdown="false"
                              :appendToBody="true"
                              :calculate-position="withPopper"
                              :clearable="false"
                              class="ftoggle">
                    </v-select>
                </li>
            </ul>
        </div>

        <div class="filter-table__list-wrap">
            <ul class="filter-table__list">
                <li class="filter-table__item">
                    <v-select v-model="city"
                              :options="cities"
                              @update:modelValue="onChangeBrand"
                              :reduce="name => name.id"
                              label="name"
                              :searchable="false"
                              :deselectFromDropdown="false"
                              :appendToBody="true"
                              :calculate-position="withPopper"
                              :clearable="false"
                              class="ftoggle">
                    </v-select>
                </li>
            </ul>
        </div> -->
    </div>

    <div class="table-responsive">
        <table class="table">
            <thead>
            <tr>
                <th v-for="th in thead">{{ th }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="row in tbody">
                <td>
                    <div
                    :style="{backgroundColor: row.tbody.line_color}"
                    class="marker marker_16px">
                </div>
                </td>
                <td>{{ row.tbody.name }}</td>
                <td>{{ row.tbody.line_name }}</td>
                <td>{{ row.tbody.city_name }}</td>
            </tr>
            </tbody>
        </table>
    </div>

    <pagination-element :count="count" :current_page="page" @pageChange="pageChange"></pagination-element>
</template>

<script>
import PaginationElement from "../../../../elements/PaginationElement";
import Station from '../../../../models/Metro/Station';
import ChangePage from "../../../../helpers/ChangePage";

export default {
    name: "StationComponent",
    components: {
        PaginationElement,
    },
    props: {
        route_list: String,
        current_page: {
            type: Number,
            default: 1
        }
    },
    data: function () {
        return {
            station: new Station({
                route_list: this.route_list,
            }),
            name: '',
            actions: [],
            thead: [
                'Цвет',
                'Название',
                'Название линии',
                'Город'
            ],
            tbody: [],
            count: 1,
            limit: 30,
            page: 1,
            // color: '',
            // colors: '',
            // line: '',
            // lines: '',
            // city: '',
            // cities: '',
        }
    },
    methods: {
        loadTable: async function () {
            let response = await this.station.loadTable(this.page, this.limit, this.name);
            this.tbody = response.tbody;
            this.count = response.pages;
            if (this.page > 1 && this.tbody.length === 0) {
                this.page = 1;
                ChangePage(this.page, false);
                await this.loadTable();
            }
        },
        pageChange: function (newPage) {
            this.page = newPage;
            this.loadTable();
        },
        onSearch: async function() {
            this.page = 1;
            await this.loadTable()
        },
        onDeleteSearch: async function () {
            if (this.name.trim() == '') {
                this.page = 1;
                await this.loadTable()
            }
        },
    },
    mounted() {
        this.loadTable();
    }
}
</script>

<style scoped>

</style>
